import React from 'react';
import { connect } from 'react-redux';
import RoleComponent from './RoleComponent';

const mapStateToProps = ({
    locationReducer,
    appReducer,
}) => {
  return {
    locationId: locationReducer.location_code,
    roles: appReducer.roles.data,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    dispatch,
  };
};

const RoleContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)((props) => {
  const {
    locationId,
    dispatch,
    roles,
  } = props;

  return <RoleComponent
    locationId={locationId}
    dispatch={dispatch}
    roles={roles}
    {...props}
  />
});

export default RoleContainer;

